// frontend/src/pages/PaychequeDetail/components/ActionsMenu.tsx
// "Make adjustment" dropdown trigger + Edit / Void / Delete action items.
// Self-contained: owns open state, outside-click, ESC-to-close.
// Parent decides what each action does (which modal to open).

import React, { useState, useEffect, useRef } from "react";
import { ChevronDown, Edit, RotateCcw, Trash2 } from "lucide-react";
import {
  outlineBtnSmall,
  dropdownMenu,
  dropdownItem,
  TEXT_SECONDARY,
  WARNING,
} from "../styles";

interface ActionsMenuProps {
  onEdit: () => void;
  onVoid: () => void;
  onDelete: () => void;
}

export default function ActionsMenu({
  onEdit,
  onVoid,
  onDelete,
}: ActionsMenuProps): React.ReactElement {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(function () {
    if (!isOpen) return;
    function onClick(e: MouseEvent) {
      if (ref.current && !ref.current.contains(e.target as Node)) setIsOpen(false);
    }
    function onEsc(e: KeyboardEvent) {
      if (e.key === "Escape") setIsOpen(false);
    }
    document.addEventListener("mousedown", onClick);
    document.addEventListener("keydown", onEsc);
    return function () {
      document.removeEventListener("mousedown", onClick);
      document.removeEventListener("keydown", onEsc);
    };
  }, [isOpen]);

  return (
    <div ref={ref} style={{ position: "relative" }}>
      <button onClick={() => setIsOpen(!isOpen)} style={outlineBtnSmall}>
        Make adjustment <ChevronDown size={11} />
      </button>

      {isOpen && (
        <div style={dropdownMenu}>
          <div
            onClick={() => { setIsOpen(false); onEdit(); }}
            style={dropdownItem}
          >
            <Edit size={13} style={{ color: TEXT_SECONDARY }} />
            Edit
          </div>
          <div
            onClick={() => { setIsOpen(false); onVoid(); }}
            style={{ ...dropdownItem, color: WARNING }}
          >
            <RotateCcw size={13} />
            Void
          </div>
          <div
            onClick={() => { setIsOpen(false); onDelete(); }}
            style={{ ...dropdownItem, color: "#DC2626" }}
          >
            <Trash2 size={13} />
            Delete
          </div>
        </div>
      )}
    </div>
  );
}